module.exports = __webpack_public_path__ + "static/media/sidebar-collapse-left.6fa0fb46.svg";